import { atom } from "jotai";

export interface IDialogHandlerStore {
  isOpen: boolean;
  dialogComponent?: JSX.Element;
}

const initialStateDialogHandlerStore: IDialogHandlerStore = { isOpen: false };

export const DialogHandlerStore = atom<IDialogHandlerStore>(initialStateDialogHandlerStore);
